import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './PinActivity.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PinMutationVariables = Types.Exact<{
  activityId: Types.Scalars['ID']['input'];
  targetGlobalId: Types.Scalars['GlobalID']['input'];
}>;


export type PinMutation = (
  { __typename?: 'Mutation' }
  & { postingsPinActivityByTarget?: Types.Maybe<(
    { __typename?: 'PostingsPinActivityResult' }
    & { success?: Types.Maybe<(
      { __typename?: 'PostingsPinnedActivity' }
      & Pick<Types.PostingsPinnedActivity, 'activityId'>
    )>, error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type PinMutationFn = Apollo.MutationFunction<PinMutation, PinMutationVariables>;

/**
 * __usePinMutation__
 *
 * To run a mutation, you first call `usePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinMutation, { data, loading, error }] = usePinMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      targetGlobalId: // value for 'targetGlobalId'
 *   },
 * });
 */
export function usePinMutation(baseOptions?: Apollo.MutationHookOptions<PinMutation, PinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinMutation, PinMutationVariables>(Operations.pin, options);
      }
export type PinMutationHookResult = ReturnType<typeof usePinMutation>;
export type PinMutationResult = Apollo.MutationResult<PinMutation>;
export type PinMutationOptions = Apollo.BaseMutationOptions<PinMutation, PinMutationVariables>;